export type BrandCategory = "husbil" | "husvagn";

export type BrandInfo = {
  slug: string;
  name: string;
  category: BrandCategory;
  origin: string;
  founded: number;
  tagline: string;
  intro: string;
  strengths: string[];
  models: string[];
  faq: { q: string; a: string }[];
};

export const HUSBIL_BRANDS: BrandInfo[] = [
  {
    slug: "rapido",
    name: "Rapido",
    category: "husbil",
    origin: "Frankrike",
    founded: 1961,
    tagline: "Fransk komfort med genomtänkt planering",
    intro:
      "Rapido är en av Europas mest respekterade husbilstillverkare — kända för hög byggkvalitet, tystgående isolering och interiörer som håller år efter år. Som auktoriserad Rapido-återförsäljare i Norrbotten känner vi märkets varje detalj.",
    strengths: [
      "Marknadsledande isolering — byggda för nordiska vintrar",
      "Genomarbetad viktbalans, många modeller körs på B-kort",
      "Franska interiörer med genuin trä- och skinnkänsla",
      "Reservdelstillgång via oss direkt från Frankrike",
    ],
    models: ["V55", "V62", "V68", "866F", "9005dfH", "Plåtis"],
    faq: [
      { q: "Är Rapido bra på vintern?", a: "Ja — Rapido har extra isolering i golv och tak och räknas som en av de bästa vinterhusbilarna i sin klass. Vi förbereder också alla utlämnade fordon för nordiskt klimat." },
      { q: "Kan jag köra Rapido på B-kort?", a: "Många Rapidomodeller ligger under 3 500 kg totalvikt och körs på vanligt B-kort. Vi märker upp B-kortsvänliga fordon direkt i lagerlistan." },
      { q: "Får jag reservdelar?", a: "Ja, vi lagerför de vanligaste Rapido-delarna och kan beställa övrigt direkt från fabrik. Se vår reservdelssida." },
    ],
  },
  {
    slug: "hymer",
    name: "Hymer",
    category: "husbil",
    origin: "Tyskland",
    founded: 1957,
    tagline: "Tysk ingenjörskonst i husbilsformat",
    intro:
      "Hymer är premiummärket från Bad Waldsee som satt standarden för europeisk husbilstillverkning. PUAL-konstruktion, extremt lång livslängd och genomtänkta planlösningar gör Hymer till ett tryggt val för långresor och åretruntbruk.",
    strengths: [
      "PUAL-kaross som motstår fukt och röta bättre än traditionella träkonstruktioner",
      "Klassledande andrahandsvärde",
      "Bred modellflora — från kompakta van till lyxiga integrerade",
      "Tysk service- och reservdelstruktur",
    ],
    models: ["B-Class", "Exsis", "ML-T", "Tramp", "Van S", "Duocar"],
    faq: [
      { q: "Håller Hymer längre än andra husbilar?", a: "Hymer PUAL-kaross är fri från trä i väggarna, vilket dramatiskt minskar risken för fuktskador — ett av de största skälen till märkets höga andrahandsvärde." },
      { q: "Är Hymer dyrare?", a: "Hymer är premium — inköpspriset är högre, men den låga värdeminskningen och bygg­kvaliteten gör totalkostnaden ofta lägre över tid." },
    ],
  },
  {
    slug: "adria",
    name: "Adria",
    category: "husbil",
    origin: "Slovenien",
    founded: 1965,
    tagline: "Prisvärd europeisk kvalitet",
    intro:
      "Adria är den slovenska tillverkaren som förenar modern design med tillgängligt prisläge. Populär bland förstagångsköpare tack vare ljusa interiörer, praktiska planlösningar och stark utrustningsnivå för pengarna.",
    strengths: [
      "Låg tröskel för första husbilen",
      "Modern design och ljusa interiörer",
      "Bra vikt/lastförhållande",
      "Stort återförsäljar- och servicenät i Europa",
    ],
    models: ["Matrix", "Coral", "Sonic", "Compact", "Twin"],
    faq: [
      { q: "Är Adria bra för nybörjare?", a: "Ja — Adria är ofta första husbilen i familjen. Enkel att hantera, ljus interiör och en prisbild som gör tröskeln lägre." },
    ],
  },
  {
    slug: "burstner",
    name: "Bürstner",
    category: "husbil",
    origin: "Tyskland",
    founded: 1958,
    tagline: "Familjär tysk husbil med hög komfortnivå",
    intro:
      "Bürstner är kända för sina familjevänliga planlösningar, tysk byggkvalitet och stor variation mellan alkovmodeller, halvintegrerade och integrerade husbilar.",
    strengths: [
      "Genomtänkta familjeplanlösningar",
      "Hög standardutrustning",
      "Tysk byggkvalitet",
      "Bra utrymme för barnfamiljer",
    ],
    models: ["Lyseo", "Ixeo", "Nexxo", "Travel Van", "Elegance"],
    faq: [],
  },
  {
    slug: "knaus",
    name: "Knaus",
    category: "husbil",
    origin: "Tyskland",
    founded: 1960,
    tagline: "Sportig design & smart teknik",
    intro:
      "Knaus är en av de största europeiska tillverkarna, kända för sportig design, teknisk innovation och deras egenutvecklade FibreFrame-teknologi som minskar rötrisken.",
    strengths: [
      "FibreFrame — rötfri kompositram istället för trä",
      "Sportig, modern formgivning",
      "Stort utbud van, halvintegrerade och alkoven",
      "Hög standardutrustning",
    ],
    models: ["Van TI", "Sky Wave", "L!ve TI", "Boxstar", "Sun TI"],
    faq: [],
  },
  {
    slug: "dethleffs",
    name: "Dethleffs",
    category: "husbil",
    origin: "Tyskland",
    founded: 1931,
    tagline: "Sveriges familjs husbil sedan 1931",
    intro:
      "Dethleffs — 'Ein Freund der Familie' — är en av världens äldsta husbilstillverkare med gedigen erfarenhet av att bygga bilar för barnfamiljer och långresor.",
    strengths: [
      "Extremt lång tillverkartradition",
      "Barnfamiljsfokus i planlösningar",
      "God vinteregenskap",
      "Bra service- och reservdelstillgång",
    ],
    models: ["Trend", "Globebus", "Just", "Alpa", "Advantage"],
    faq: [],
  },
];

export const HUSVAGN_BRANDS: BrandInfo[] = [
  {
    slug: "kabe",
    name: "Kabe",
    category: "husvagn",
    origin: "Sverige (Tenhult)",
    founded: 1958,
    tagline: "Svensk husvagn för åretruntbruk",
    intro:
      "Kabe är den svenska premiumhusvagnen — byggd i Tenhult, konstruerad för nordisk vinter och känd över hela Europa som referens för åretruntstandard. AL-KO-chassi, dubbla isolerade golv och genomtänkta detaljer.",
    strengths: [
      "Konstruerad för svenska vintrar (−32 °C-testad)",
      "Dubbla isolerade golv i alla modeller",
      "Högst andrahandsvärde på svenska marknaden",
      "AL-KO-chassi med automatisk stabilisator",
    ],
    models: ["Royal", "Imperial", "Estate", "Ädelsten", "Classic"],
    faq: [
      { q: "Varför är Kabe så dyrt?", a: "Kabe bygger med dubbla isolerade golv, tjockare väggar och svensk arbetskraft. Det märks i vinterkomfort och i värdet vid försäljning år 8 — där Kabe ofta ligger 20–30 % över konkurrenter." },
      { q: "Går Kabe att använda på vintern?", a: "Ja, Kabe är byggd för åretruntbruk. Många av våra kunder använder sin Kabe hela vintern i Norrbotten utan problem." },
    ],
  },
  {
    slug: "polar",
    name: "Polar",
    category: "husvagn",
    origin: "Sverige (Dorotea)",
    founded: 1965,
    tagline: "Norrländsk husvagn — byggd för kylan",
    intro:
      "Polar tillverkas i Dorotea i södra Lappland och är svensk husvagn i ordets sanna bemärkelse. Robusta konstruktion, hög isoleringsklass och skandinaviskt formspråk gör Polar till en självklar konkurrent till Kabe.",
    strengths: [
      "Byggd i Sverige för svenska förhållanden",
      "Hög isoleringsstandard",
      "Praktiska svenska planlösningar",
      "Stark ställning i norra Sverige",
    ],
    models: ["Original", "Cup"],
    faq: [
      { q: "Vad är skillnaden mellan Polar och Kabe?", a: "Polar är prisvärdare med snarlik isolering och byggkvalitet — Kabe har historiskt sett högre andrahandsvärde och lyxigare detaljer. Båda är byggda för svensk vinter." },
    ],
  },
  {
    slug: "adria",
    name: "Adria",
    category: "husvagn",
    origin: "Slovenien",
    founded: 1965,
    tagline: "Modern europeisk husvagn till bra pris",
    intro:
      "Adria husvagnar är populära för sina ljusa, moderna interiörer och skarpa prisläge. Bra val för familjer som vill komma igång utan att köpa premium.",
    strengths: [
      "Skarpt prisläge",
      "Modern, ljus interiör",
      "Bra lastvikt",
      "Stort utbud modeller & planlösningar",
    ],
    models: ["Adora", "Alpina", "Astella", "Altea", "Aviva"],
    faq: [],
  },
  {
    slug: "cabby",
    name: "Cabby",
    category: "husvagn",
    origin: "Sverige (Kinna)",
    founded: 1962,
    tagline: "Svenskbyggd husvagn med personlighet",
    intro:
      "Cabby tillverkas i Kinna och är känd för sina eleganta interiörer, hantverksdetaljer och trogen kundkrets. En av de tre stora svenskbyggda husvagnarna tillsammans med Kabe och Polar.",
    strengths: [
      "Svensktillverkad kvalitet",
      "Genuint hantverk i interiören",
      "Trogen kundkrets och god andrahandsvärde",
      "Nordisk vinterstandard",
    ],
    models: ["Caienna", "Comfort"],
    faq: [],
  },
  {
    slug: "knaus",
    name: "Knaus",
    category: "husvagn",
    origin: "Tyskland",
    founded: 1960,
    tagline: "Tysk husvagn med sportig design",
    intro:
      "Knaus husvagnar är populära i hela Europa för sin moderna design och tekniska innovation, bland annat den egenutvecklade FibreFrame-tekniken som ersätter trä med komposit och minskar risken för fuktskador.",
    strengths: [
      "FibreFrame — rötfri konstruktion",
      "Modern tysk design",
      "Bred modellflora",
      "Hög standardutrustning",
    ],
    models: ["Südwind", "Sport", "Deseo", "Yaseo", "Azur"],
    faq: [],
  },
];

export const ALL_BRANDS: BrandInfo[] = [...HUSBIL_BRANDS, ...HUSVAGN_BRANDS];

export function getBrand(category: BrandCategory, slug: string): BrandInfo | undefined {
  return ALL_BRANDS.find((b) => b.category === category && b.slug === slug);
}
